import script from "./confirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirm.vue?vue&type=script&lang=ts&setup=true"

import "./confirm.vue?vue&type=style&index=0&id=1cfafded&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cfafded"]])

export default __exports__